<template>
    <div>
        <b-input-group>
            <b-input-group-text><i class="fas fa-filter mr-1"></i>Filter</b-input-group-text>
            <b-input-group-prepend>
                <b-button variant="secondary" v-on:click="editFilter" v-if="!filterPanelOpen" key="editfilter"><i class="fas fa-pen mr-1"></i>Edit</b-button>
                <b-button id="applyButton" :variant="filterDirty ? 'success' : 'secondary'" v-on:click="applyFilter" v-if="filterPanelOpen" key="applyfilter"><i class="fas fa-check mr-1"></i>Apply</b-button>
                <b-button id="cancelButton" :variant="filterDirty ? 'danger' : 'secondary'" v-on:click="resetFilter" v-if="filterPanelOpen" key="resetfilter"><i class="fas fa-times mr-1"></i>Cancel</b-button>
                <b-button id="clearButton" :variant="(this.filterDisplayText != null ) ? 'danger' : 'secondary'" v-on:click="clearFilter" v-if="!filterPanelOpen" key="clearfilter"><i class="fas fa-times mr-1 no-radius"></i>Clear</b-button>
                <b-dropdown text="Quick Filters" v-if="hasNamedQuickFilters" key="quickfilters">
                    <template v-for="(quickFilter, index) in quickFilters">
                        <b-dropdown-item :key="'quickfilter' + index" :class="quickFilter.shared ? 'font-italic' : ''" v-on:click="applyQuickFilter(quickFilter)" v-if="quickFilter.name">{{ quickFilter.name }}</b-dropdown-item>
                    </template>
                </b-dropdown>
            </b-input-group-prepend>

            <b-form-input readonly :value="filterStatus"></b-form-input>
            <template v-if="filterPanelOpen && (currentFilter != null)">
                <b-form-input placeholder="Custom filter name" v-model="customFilterName" maxlength="100"></b-form-input>

                <b-input-group-append>
                    <b-button :variant="(customFilterName == null) || (customFilterName.length == 0) || ((oldCustomFilterName == customFilterName) && !filterDirty) ? 'secondary' : 'success'" :disabled="(currentFilter.rules.length==0) || (customFilterName == null) || (customFilterName.length == 0) || ((oldCustomFilterName == customFilterName) && !filterDirty)" v-on:click="saveQuickFilter">Save Filter</b-button>
                    <b-button variant="danger" v-on:click="deleteQuickFilter" v-if="((currentQuickFilter != null) && !currentQuickFilter.shared && !currentQuickFilter.default)">Delete Filter</b-button>
                </b-input-group-append>
            </template>
        </b-input-group>
        <b-collapse id="filterpanel" v-model="filterPanelOpen">
            <b-card>
                <filter-builder ref="filterBuilder" :fields="fields" :filter="currentFilter" @change="filterChanged"></filter-builder>
            </b-card>
        </b-collapse>
    </div>
</template>

<script>
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    import axios from 'axios';
    import ErrorsMixin from '../../mixins/ErrorsMixin';
    import DateTimeMixin from '../../mixins/DateTimeMixin';
    import UuidMixins from '../../mixins/UuidMixins';

    import FilterBuilder from '../FilterBuilder/FilterBuilder';

    Vue.use(BootstrapVue);
    
    Vue.component('filter-builder', FilterBuilder);

    export default {
        name: 'FilterUI',
        mixins: [ErrorsMixin, DateTimeMixin, UuidMixins],
        model: {
            event: 'change',
            prop: 'filter'
        },
        props: {
            fields: {
                type: Array,
                required: true
            },
            /*
            quickFilters: {
                type: Array,
                default: null
            }, */
            filter: {
                type: Object,
                default: null
            },
            relatedTo: {
                type: String,
                default: null
            },
            apiBaseUrl: {
                String,
                default: null,
                required: true
            }
        },

        data: function () {
            return {
                quickFilters: null,
                currentQuickFilter: null,

                currentFilter: this.filter,
                previousFilter: null,
                filterPanelOpen: false,
                filterDirty: false,
                filterDisplayText: null,

                customFilterName: null,
                oldCustomFilterName: null,
            }
        },
        watch: {
            filter: function () {
                this.currentQuickFilter = null;
                this.currentFilter = this.filter;
                this.$nextTick(() => {
                    if (this.$refs.filterBuilder) this.filterDisplayText = this.$refs.filterBuilder.filterDisplayText;
                    else this.filterDisplayText = null;
                });
            }
        },
        computed: {
            hasNamedQuickFilters: function () {
                if (this.quickFilters == null) return false;
                var quickFilter = this.quickFilters.find(q => q.name && q.name.length);
                return (quickFilter != null);
            },
            filterStatus: function () {
                if (this.filterDisplayText) return this.filterDisplayText;
                return "Inactive";
            }
        },
        methods: {
            loadQuickFilters: function () {
                var url = this.apiBaseUrl + '/quickfilter/list/' + this.relatedTo;
                return axios
                    .get(url)
                    .then(response => {
                        this.quickFilters = response.data;
                        if (!this.currentFilter && this.quickFilters) {
                            var defaultQuickFilter = this.quickFilters.find(qf => qf.default);
                            if (defaultQuickFilter) {
                                this.applyQuickFilter(defaultQuickFilter);
                            }
                        }
                        return true;
                    })
                    .catch(ex => {
                        var errors = this.handleAxiosException(ex);
                        this.showErrorsToast(errors);
                        return false;
                    });
            },

            saveQuickFilter: function () {

                if (this.customFilterName == null || this.customFilterName.trim() == '') {
                    this.$bvToast.toast('Quick filter not saved! Please provide a name.', {
                        title: 'Quick Filter',
                        variant: 'danger',
                        appendToast: true
                    });
                    return;
                }

                var id = this.emptyUuid;
                if ((this.currentQuickFilter != null) && !this.currentQuickFilter.shared && !this.currentQuickFilter.default)
                    id = this.currentQuickFilter.id;
                var quickFilter = {
                    id: id,
                    name: this.customFilterName.trim(),
                    default: false,
                    shared: false,
                    filter: this.currentFilter
                };

                var url = this.apiBaseUrl;
                if (!url.endsWith('/')) url += '/';
                url += 'quickfilter/' + this.relatedTo;

                axios
                    .post(url, JSON.stringify(quickFilter),
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                    .then(response => {
                        this.currentQuickFilter = response.data;
                        this.$bvToast.toast('Quick filter saved successfully.', {
                            title: 'Quick Filter:',
                            variant: 'success',
                            appendToast: true
                        });
                        this.loadQuickFilters();
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    });
            },

            deleteQuickFilter: function () {
                var url = this.apiBaseUrl;
                if (!url.endsWith('/')) url += '/';
                url += 'quickfilter/' + this.currentQuickFilter.id;
                  axios
                    .delete(url)
                    .then(() => {
                        this.loadQuickFilters();
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    })
                    .finally(() => {
                          this.customFilterName = null;
                          this.currentQuickFilter = null;
                    });
            },

            editFilter: function () {
                this.oldCustomFilterName = this.customFilterName;
                this.previousFilter = this.currentFilter;
                this.filterPanelOpen = true;
                this.$nextTick(() => {
                    this.$refs.filterBuilder.refresh();
                });
            },
            filterChanged: function (filter) {
                this.currentFilter = filter;
                this.filterDirty = true;
            },
            resetFilter: function () {
                this.currentFilter = this.previousFilter;
                this.filterDirty = false;
                this.filterPanelOpen = false;
            },
            applyFilter: function () {
                this.filterDisplayText = this.$refs.filterBuilder.filterDisplayText;
                this.filterDirty = false;
                this.filterPanelOpen = false;
                this.$emit('change', this.currentFilter);
            },
            applyQuickFilter: function (quickFilter) {

                // applying custom filter name to text input field
                this.customFilterName = (quickFilter.shared || quickFilter.default) ? null : quickFilter.name;
                this.currentQuickFilter = quickFilter;
                var filterString = JSON.stringify(quickFilter.filter);
                this.currentFilter = JSON.parse(filterString, (key, value) => {
                    if (value && (typeof value === 'string')) {
                        var today = this.formatDateTime(this.now(), 'DD/MM/YYYY', false, false);
                        value = value.replace(/\${today}/gi, today);
                        var thisWeekStart = this.formatDateTime(this.weekStart(), 'DD/MM/YYYY', false, false);
                        var thisWeekEnd = this.formatDateTime(this.weekEnd(), 'DD/MM/YYYY', false, false);
                        value = value.replace(/\${thisweekstart}/gi, thisWeekStart);
                        value = value.replace(/\${thisweekend}/gi, thisWeekEnd);
                        var lastWeekStart = this.formatDateTime(this.weekStart(-1), 'DD/MM/YYYY', false, false);
                        var lastWeekEnd = this.formatDateTime(this.weekEnd(-1), 'DD/MM/YYYY', false, false);
                        value = value.replace(/\${lastweekstart}/gi, lastWeekStart);
                        value = value.replace(/\${lastweekend}/gi, lastWeekEnd);
                        var thisMonthStart = this.formatDateTime(this.monthStart(), 'DD/MM/YYYY', false, false);
                        var thisMonthEnd = this.formatDateTime(this.monthEnd(), 'DD/MM/YYYY', false, false);
                        value = value.replace(/\${thismonthstart}/gi, thisMonthStart);
                        value = value.replace(/\${thismonthend}/gi, thisMonthEnd);
                        var lastMonthStart = this.formatDateTime(this.monthStart(-1), 'DD/MM/YYYY', false, false);
                        var lastMonthEnd = this.formatDateTime(this.monthEnd(-1), 'DD/MM/YYYY', false, false);
                        value = value.replace(/\${lastmonthstart}/gi, lastMonthStart);
                        value = value.replace(/\${lastmonthend}/gi, lastMonthEnd);
                        var thisQuarterStart = this.formatDateTime(this.quarterStart(), 'DD/MM/YYYY', false, false);
                        var thisQuarterEnd = this.formatDateTime(this.quarterEnd(), 'DD/MM/YYYY', false, false);
                        value = value.replace(/\${thisquarterstart}/gi, thisQuarterStart);
                        value = value.replace(/\${thisquarterend}/gi, thisQuarterEnd);
                        var lastQuarterStart = this.formatDateTime(this.quarterStart(-1), 'DD/MM/YYYY', false, false);
                        var lastQuarterEnd = this.formatDateTime(this.quarterEnd(-1), 'DD/MM/YYYY', false, false);
                        value = value.replace(/\${lastquarterstart}/gi, lastQuarterStart);
                        value = value.replace(/\${lastquarterend}/gi, lastQuarterEnd);
                        var thisYearStart = this.formatDateTime(this.yearStart(), 'DD/MM/YYYY', false, false);
                        var thisYearEnd = this.formatDateTime(this.yearEnd(), 'DD/MM/YYYY', false, false);
                        value = value.replace(/\${thisyearstart}/gi, thisYearStart);
                        value = value.replace(/\${thisyearend}/gi, thisYearEnd);
                        var lastYearStart = this.formatDateTime(this.yearStart(-1), 'DD/MM/YYYY', false, false);
                        var lastYearEnd = this.formatDateTime(this.yearEnd(-1), 'DD/MM/YYYY', false, false);
                        value = value.replace(/\${lastyearstart}/gi, lastYearStart);
                        value = value.replace(/\${lastyearend}/gi, lastYearEnd);

                        return value;
                    }
                    return value;
                });
                
                this.$nextTick(() => {
                    if (this.$refs.filterBuilder) this.filterDisplayText = this.$refs.filterBuilder.filterDisplayText;
                    else this.filterDisplayText = null;
                });
                this.filterDirty = false;
                this.filterPanelOpen = false;
                this.$emit('change', this.currentFilter);

            },
            clearFilter: function () {
                this.currentFilter = null;
                this.filterDisplayText = null;
                this.filterDirty = false;
                this.filterPanelOpen = false;
                this.customFilterName = null;
                this.currentQuickFilter = null;
                this.$emit('change', this.currentFilter);
            },
        },
        mounted: function () {
            this.$nextTick(() => {
                if (this.$refs.filterBuilder) this.filterDisplayText = this.$refs.filterBuilder.filterDisplayText;
                else this.filterDisplayText = null;
            });
        }
    }
</script>
<style scoped>
    .e-rule-field {
        display: flex;
        align-items: center;
    }

    .e-template-value {
        flex-grow: 1;
    }

    .e-template-value .e-multiselect {
        max-width: none !important;
    }

    .e-template-value .e-multi-select-wrapper {
        max-width: none !important;
    }
    
</style>